(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('RequestService', RequestService);

    RequestService.$inject = ['$q', '$rootScope', '$injector', 'API_CONFIG', '$location'];

    function RequestService($q, $rootScope, $injector, API_CONFIG, $location) {

        var service = {
            baseUrl: baseUrl,
            apiUrl: apiUrl,
            cancelRequests: cancelRequests
        };

        return service;

        // Return the base url of the api concatenated with the path passed as parameter
        function baseUrl(path) {
            var api = $location.protocol() + "://" + $location.host() + API_CONFIG.apiPort + '/' + path;
            return api;
        }

        // Return the api url concatenated with the path and method passed as parameters
        function apiUrl(path, method) {
            if (path.charAt(path.length - 1) == '/') {
                path = path.slice(0, path.length - 1);
            }
            return baseUrl('api/' + path + (method ? '/' + method : ''));
        }

        // Cancel the pending requests
        function cancelRequests(urls) {
            var $http = $injector.get('$http');
            $http.pendingRequests.forEach(function (request) {
                // If urls param is passed, should only cancel the request that is in the list
                var cancel = urls ? isCancelable(urls, request) : true;
                // Only cancel GET requests that have the cancel property set to true
                if (cancel && request.cancel) {
                    // Resolve the promise to cancel the request
                    request.cancel.resolve();
                    // Set the canceled flag to true, so canceled errors cannot be triggered again
                    request.canceled = true;
                }
            });
        }

        // Check if the request url is in the urls parameter
        function isCancelable(path, request) {
            if (angular.isArray(path)) {
                // If the path is an array check if url is equal to one of its elements
                for (var i = 0; i < path.length; i++) {
                    if (request.url == apiUrl(path[i])) {
                        return true;
                    }
                }
            } else {
                // If the path is not an array, check if the url contains it
                if (request.url.indexOf(path) > -1) {
                    return true;
                }
            }
            return false;
        }

    }
})();
